/// <reference types="vite/client" />
// ============================================================
// HARMONIC CHARTER — Supabase Client
// ============================================================

import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL  = import.meta.env.VITE_SUPABASE_URL as string;
const SUPABASE_ANON = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!SUPABASE_URL || !SUPABASE_ANON) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON, {
  auth: {
    autoRefreshToken:   true,
    persistSession:     true,
    detectSessionInUrl: true,
  },
});

// ── Database types ─────────────────────────────────────────

export interface DbSong {
  id:         string;
  owner_id:   string;
  title:      string;
  data:       object;
  created_at: string;
  updated_at: string;
}

export interface DbCollaborator {
  id:         string;
  song_id:    string;
  owner_id:   string;
  email:      string;
  user_id:    string | null;
  role:       'viewer' | 'editor';
  invited_at: string;
  accepted:   boolean;
}